<template>
   <div class="grid mt-1"> 
     <Loader v-if="loader" />       
      <div class="col-12">

        <AutoComplete
          v-model="selectedCliente"
          dropdown
          :suggestions="clientiSuggeriti"
          @complete="prendiClienti"
          class="inputfield w-full"
          placeholder="Seleziona un cliente"
          optionLabel="code"
          @select="onChange"
        >
          <template #value="{value, placeholder}">
                <div class="client-item client-item-value" v-if="value">
                    <div>{{(value.ragsoc) ? value.ragsoc : value.nome +" "+ value.cognome}} - {{value.code}}</div>
                </div>
                <span v-else>
                    {{placeholder}}
                </span>
            </template>
            <template #option="slotProps">
                <div class="client-item">
                    <div v-if="slotProps.option.ragsoc">{{slotProps.option.ragsoc}} - <small>{{(slotProps.option.piva) ? slotProps.option.piva : slotProps.option.codfis}} - {{slotProps.option.code}}</small></div>
                    <div v-else>{{slotProps.option.nome}}&nbsp;{{slotProps.option.cognome}} - <small>{{slotProps.option.codfis}} - {{slotProps.option.code}}</small></div>
                </div>
            </template>
        </AutoComplete>

        <div v-if="selectedCliente && saldo_totale != null" class="col-12">

            <div v-if="saldo_totale == 0">
              <div class="wrapper-saldo-totale">
                <small class="mx-4">Il saldo totale di {{selectedCliente.name}} è uguale a 0 €</small>
              </div>
              <div v-if="fattureRemoved.length > 0" class="mt-3 wrapper-info-movement">
                <div class="grid">
                  <div class="col-3 flex justify-content-center align-items-center">
                    <i class="pi pi-exclamation-circle"></i>
                  </div>
                  <div class="col-9">
                    <small class="p-error">
                      Il saldo è uguale a 0 perchè questo movimento è {{estrattoConto.value > 0 ? 'positivo' : 'negativo'}} e 
                      sembra che ci siano fatture da associare per movimenti {{estrattoConto.value > 0 ? 'negativi' : 'positivi'}}
                    </small>
                  </div>
                </div>
              </div> 
            </div>

            <div v-else>
              <div class="wrapper-saldo-totale">
                <small class="mx-4">Saldo totale: {{saldo_totale}} €</small>
              </div>

                <div v-if="fattureDaSaldare.length > 0" class="mt-3">

                  <DataTable dataKey="numero" :value="fattureDaSaldare" responsiveLayout="scroll" v-model:selection="selectedFatture" scrollHeight="400px" @row-select-all="onChangeAllRows" @row-unselect-all="onChangeAllRows">
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                      <Column field="label" header="Info"></Column>
                      <Column  header="Saldo">
                        <template #body="{data}">
                            <p class="p-error">
                              {{data.saldo.toFixed(2)}}
                            </p> 
                        </template>
                      </Column>
                      <Column  header="Pagato">
                        <template #body="{data}">
                            {{data.pagato.toFixed(2)}}
                        </template>
                      </Column>
                      <Column  header="Totale Fattura">
                        <template #body="{data}">
                            {{data.totale.toFixed(2)}}
                        </template>
                      </Column>
                      <Column field="modified" header="Modificato">
                        <template #body="{data}">
                          <small v-if="data.modified" @click="resetSaldo(data)" class="p-error p-reset"> Ripristina </small>
                        </template>
                      </Column>
                  </DataTable>

                  <div class="chip-selected-suggest mt-3 p-fluid">
                    <Chips v-model="selectedFatture" @keypress.prevent="false">
                      <template #chip="slotProps">
                          <div v-if="slotProps.value.real" @click="openEditSaldoDialog(slotProps.value)" class="chip-basic">
                              <div class="title-chip">{{slotProps.value.numero}}</div>
                              <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                              <i  class="icon-edit-saldo pi pi-pencil ml-2" style="font-size: 10px"></i>
                          </div>
                          <div v-else class="chip-special">
                              <div class="title-chip">{{slotProps.value.numero}}</div>
                              <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                              <span class="compensation"><i class="pi pi-clone"></i></span>
                          </div>
                      </template>   
                    </Chips>
                  </div>

                  <div class="my-2 md:mt-0 flex align-items-center">
                    <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
                      <div 
                      class="p-bar h-full" 
                      :style="{ width: percentage +'%'}"
                      :class="(percentage == 100) ? 'bg-blue-500' : (percentage > 100) ? 'bg-red-500': 'bg-yellow-500'"
                      >
                      </div>
                    </div>
                  </div>

                  <div class="grid">
                    <div class="col-4 flex justify-content-start">
                      <div class="text-left">
                        <p class="title-bar">ASSOCIATO</p>
                        <b  class="num-bar text-yellow-500">{{selectedSum.toFixed(2)}}</b>
                      </div>
                    </div>
                    <div class="col-4 flex justify-content-center">
                      <div class="text-left">
                        <p class="title-bar">RIMANENTI</p>
                        <b class="num-bar p-error">{{( Math.abs(estrattoConto.value) - selectedSum).toFixed(2)}}</b>
                      </div>
                    </div>
                    <div class="col-4 flex justify-content-end">
                      <div class="text-left">
                        <p class="title-bar">TOTALE</p>
                        <b class="num-bar text-blue-500">{{estrattoConto.value}} </b> &euro;
                      </div>
                    </div>
                  </div> 

                  <div class="mt-3 text-right">
                      <Button 
                      @click="associa" 
                      label="Associa movimento" 
                      class="p-button-outlined" 
                      :disabled="selectedSum.toFixed(2) != Math.abs(estrattoConto.value)" 
                      :class="selectedSum.toFixed(2) != Math.abs(estrattoConto.value) ? 'p-button-secondary' : ' p-button-primary'" 
                      />
                  </div>

                </div>
                 
            </div>

        </div>
      </div>
   </div>

   <!-- DIALOG EDIT SALDO CHIP -->
    <Dialog v-model:visible="editSaldoDialog" :style="{width: '450px'}" header="Modifica" :modal="true">
        <div class="confirmation-content">
            <div v-if="estrattoConto">Inserisci l'importo <br>
              <InputText type="text" v-model="temp.saldo_modificato" class="inputfield w-full mt-2" :class="{'p-invalid': validationErrors.saldo && submitted }" />
              <small class="p-error" v-if="validationErrors.saldo && submitted">Valore non valido (totale dei selezionati supera l'importo del movimento)</small>
            </div> 
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="editSaldoDialog = false"/>
            <Button label="Modifica" icon="pi pi-check" class="p-button-text" @click="editSaldo" />
        </template>
    </Dialog>


</template>

<script>
import { ref, onMounted, getCurrentInstance, computed, watch  } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const loader = ref(false)
    const estrattoConto = ref(props.detail)
    const selectedCliente = ref()
    const clientiSuggeriti = ref([])
    const saldo_totale = ref(null)
    const fattureDaSaldare = ref([])
    const fattureRemoved = ref([])
    const selectedFatture = ref([])
    const editSaldoDialog = ref(false)
    const temp = ref(null)
    const submitted = ref(false);
    const validationErrors = ref({})

    onMounted(() => {
    })

    const prendiClienti = (event) => {
      loader.value = true
      service.getClientiSuggeriti(event.query).then((res) => {
        clientiSuggeriti.value = res.items
      }).finally(() => {
        loader.value = false
      }) 
    }

    watch(selectedCliente, (val) => {
      if (val && val.id) {
        onChange();
      }
    });

    const onChange = () => {

      console.log('onChange triggered', selectedCliente.value);

      saldo_totale.value = null
      fattureDaSaldare.value = []
      if (selectedCliente.value.id != null) {

            service.getFattureDaSaldareClient(selectedCliente.value.id).then((res) => {
              if (res.items.length > 0) {
                 const response = res.items.map((el) =>{
                  el.modified = false
                  el.real = true
                  el.saldo_modificato = el.saldo
                  return el
                })

                if (estrattoConto.value.value > 0) {
                  fattureDaSaldare.value = response.filter((el) => el.saldo > 0)
                  fattureRemoved.value = response.filter((el) => el.saldo < 0)
                } else {
                  fattureDaSaldare.value = response.filter((el) => el.saldo < 0)
                  fattureRemoved.value = response.filter((el) => el.saldo > 0)
                }
                saldo_totale.value = (fattureDaSaldare.value.reduce((prev, curr) => prev + curr.saldo, 0)).toFixed(2)

                let total = 0
                let residuo = 0
                let complete = false
                selectedFatture.value = fattureDaSaldare.value.filter(el => {
                  
                  total += el.saldo_modificato
 
                  if (!complete) {
                    if ( Math.abs(total) <=  Math.abs(estrattoConto.value.value)) {
                      return el
                    } else {
                      total -= el.saldo_modificato
                      residuo = estrattoConto.value.value - total
                      el.saldo_modificato = residuo
                      el.modified = true
                      complete = true
                      return el
                    }                
                  }
                })

                addVirtualFattura()

              } else {
                saldo_totale.value = 0
              } 
            })
      }
    }

    const onChangeAllRows = () => {
      addVirtualFattura()
    }

    // create virtual fattura if movimeto > saldo_totale
    const addVirtualFattura = () => {
      fattureDaSaldare.value = fattureDaSaldare.value.filter((el) => el.real == true) // return only real fatture into datatable
      if (Math.abs(estrattoConto.value.value) > Math.abs(saldo_totale.value)) {
        let virtualExist = selectedFatture.value.filter((el) => el.real == false)
        if (virtualExist.length == 0) {
          const val = (estrattoConto.value.value - saldo_totale.value)
          const virtualFattura = {...selectedFatture.value[selectedFatture.value.length -1]}
          virtualFattura.saldo_modificato = val
          virtualFattura.real = false
          selectedFatture.value.push(virtualFattura)
        } 
      }
    }


    const selectedSum = computed(() => {
        return selectedFatture.value.reduce((old, el) =>  Math.abs(old) +  Math.abs(el.saldo_modificato), 0)
    })

    const percentage = computed(() => {
        return ((100 * Math.abs(selectedSum.value)) / Math.abs(estrattoConto.value.value)).toFixed(2)
    })

    const associa = () => {
        const obj = estrattoConto.value
        obj.payments = selectedFatture.value
        service.associateToPayments(obj).then((res)=> {
          if (res) {
            emit('movement-regularized',{id: estrattoConto.value.id})
          }
        }) 
    }

    const resetSaldo = (el) => {
      el.saldo_modificato =  el.saldo
      el.modified = false
    }

    const openEditSaldoDialog = (el) => {
      submitted.value = false;
      temp.value = null
      temp.value = {...el}
      temp.value.saldo_modificato = temp.value.saldo_modificato.toFixed(2)
      editSaldoDialog.value = true
    }

     const editSaldo = () => {
        submitted.value = true;
        temp.value.saldo_modificato = temp.value.saldo_modificato.toString()
        temp.value.saldo_modificato = temp.value.saldo_modificato.replaceAll(',','.')
        temp.value.saldo_modificato = parseFloat(temp.value.saldo_modificato)
        temp.value.saldo_modificato = estrattoConto.value.value < 0 ? Math.abs(temp.value.saldo_modificato) * -1 : Math.abs(temp.value.saldo_modificato)
        
        selectedFatture.value = selectedFatture.value.filter(el => {
          if (el.numero == temp.value.numero && el.real == true) {
            let saldo_temp = el.saldo_modificato
            el.saldo_modificato = temp.value.saldo_modificato
            const valid = verifyIsValid()
            if (valid) {
              el.modified = true
              editSaldoDialog.value = false
              return el
            } else {
              el.saldo_modificato = saldo_temp
              return el
            }
          } else {
            return el
          }
        })    
      }

      const verifyIsValid = () => {

        if(parseFloat(Math.abs(selectedSum.value).toFixed(2)) > parseFloat(Math.abs(estrattoConto.value.value).toFixed(2))) {
          validationErrors.value['saldo'] = true;
          return false
        } else {
          delete validationErrors.value['saldo'];
          return true
        }
      }


    return {
      estrattoConto,
      selectedCliente,
      clientiSuggeriti,
      onChange,
      saldo_totale,
      fattureDaSaldare,
      selectedFatture,
      percentage,
      selectedSum,
      associa,
      editSaldoDialog,
      openEditSaldoDialog,
      temp,
      validationErrors, 
      submitted,
      editSaldo,
      resetSaldo,
      onChangeAllRows,
      fattureRemoved,
      loader,
      prendiClienti
    }
  },
}
</script>

<style>
.wrapper-saldo-totale {
  background-color: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
  text-align: center;

}
.chip-selected-suggest .p-chips-token .compensation {
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 9px;
  background: white;
  padding: 2px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chip-selected-suggest .p-chips-token .compensation i{
  font-size: 10px;
  color: black;
}
.wrapper-info-movement {
  background-color: rgba(253, 174, 174, 0.616);
  border-radius: 8px;
}
.wrapper-info-movement i{
 color: white;
 font-size: 20px;
}
</style>
